import React from 'react';
import classNames from 'classnames';

import 'components/button/button.scss';

export enum ButtonType {
  primary,
  secondary,
  primaryLarge,
  primarySmall,
  circleNext,
  circlePrev,
  circleDone,
  circleBack,
  circleDownload,
  circleIconRocket,
  circlePlaceholder,
  circleClose
}

interface ButtonProps {
  type?: ButtonType;
  disabled?: boolean;
  label?: string;
  extraClasses?: string;
  onClick?: (event: React.SyntheticEvent<{ value: string }>) => void;
}

const defaultProps: ButtonProps = {
  type: ButtonType.primary,
  label: 'Button Label',
  disabled: false
};

const Button: React.SFC<ButtonProps> = props => (
  <button
    className={classNames('c-button', props.extraClasses, {
      'c-button--primary c-button--medium': props.type === ButtonType.primary,
      'c-button--secondary c-button--small':
        props.type === ButtonType.secondary,
      'c-button--primary c-button--large':
        props.type === ButtonType.primaryLarge,
      'c-button--primary c-button--small':
        props.type === ButtonType.primarySmall,
      'c-button--circle c-button--next': props.type === ButtonType.circleNext,
      'c-button--circle c-button--prev': props.type === ButtonType.circlePrev,
      'c-button--circle c-button--prev c-button--back':
        props.type === ButtonType.circleBack,
      'c-button--circle c-button--ok': props.type === ButtonType.circleDone,
      'c-button--circle c-button--ok c-button--download':
        props.type === ButtonType.circleDownload,
      'c-button--circle c-button--rocket':
        props.type === ButtonType.circleIconRocket,
      'c-button--circle c-button--close': props.type === ButtonType.circleClose,
      'c-button--circle c-button--placeholder':
        props.type === ButtonType.circlePlaceholder,
      'c-button--disabled': props.disabled
    })}
    disabled={props.disabled}
    onClick={props.onClick}
  >
    {props.label}
  </button>
);

Button.defaultProps = defaultProps;

export default Button;



// WEBPACK FOOTER //
// ./src/components/button/button.tsx